import { render } from "./PreviewImg.vue?vue&type=template&id=98bd85d2&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=js"
export * from "./PreviewImg.vue?vue&type=script&lang=js"

import "./PreviewImg.vue?vue&type=style&index=0&id=98bd85d2&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98bd85d2"]])

export default __exports__